import * as React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'
import { GraySection } from '../GraySection'
import { useQueryParam } from '../../hooks/useQueryParam'

import nubrakesOutline from '../../../public/img/nubrakes-logo-no-text.svg'
type Props = {
  title: string
}

export const PricingScheduleService: React.FC<Props> = ({ title }) => {
  const query = useQueryParam()
  return (
    <GraySection className="text-center">
      <Container>
        <div>
          <div className="pb-4 text-center">
            <Image src={nubrakesOutline} alt={'NuBrakes Logo'} className={'mx-auto'} />
          </div>
          <h2 className="title">{title}</h2>
          <p className="description">
            Service currently available in{' '}
            <Link as={{ pathname: `/cities/austin-brake-repair/`, query }} href={'/cities/[slug]'}>
              Austin, TX
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/houston-brake-repair/`, query }} href={'/cities/[slug]'}>
              Houston, TX
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/san-antonio-brake-repair/`, query }} href={'/cities/[slug]'}>
              San Antonio, TX
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/dallas-brake-repair/`, query }} href={'/cities/[slug]'}>
              Dallas, TX
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/atlanta-brake-repair/`, query }} href={'/cities/[slug]'}>
              Atlanta, GA
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/nashville-brake-repair/`, query }} href={'/cities/[slug]'}>
              Nashville, TN
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/tampa-brake-repair/`, query }} href={'/cities/[slug]'}>
              Tampa, FL
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/orlando-brake-repair/`, query }} href={'/cities/[slug]'}>
              Orlando, FL
            </Link>
            ,{' '}
            <Link as={{ pathname: `/cities/jacksonville-brake-repair/`, query }} href={'/cities/[slug]'}>
              Jacksonville, FL
            </Link>
            <Link as={{ pathname: `/cities/miami-brake-repair/`, query }} href={'/cities/[slug]'}>
              Miami, FL
            </Link>
            <Link as={{ pathname: `/cities/chicago-brake-repair/`, query }} href={'/cities/[slug]'}>
              Chicago, IL
            </Link>
          </p>
        </div>
        <div className="pt-5">
          <LandingPageButton buttonText={'Schedule My Brake Repair'} />
        </div>
      </Container>
    </GraySection>
  )
}
